
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<ScreenBottomButton>({})
export default class ScreenBottomButton extends Vue {
    @Prop(String) public title!: string
    @Prop(String) public icon?: string
    @Prop({ type: Boolean, default: false })
    public makeRelative?: boolean

    public handleClick() {
        this.$emit('click')
    }
}
